export default __webpack_public_path__ + "static/media/24t.f7832847.jpg";